import ArrowRight from '../../media/arrow-right.svg';
import ArrowRightHover from '../../media/arrow-right-hover.svg';
import ArrowLeft from '../../media/arrow-left.svg';
import ArrowLeftFocus from '../../media/arrow-left-focus.svg';

export function getChatLabelStyles() {
  return {
    container: {
      zIndex: 1000,
      position: 'fixed',
      bottom: 45,
      right: 0,
      display: 'flex',
      padding: '1px 0px 1px 1px',
      backgroundColor: 'white',
      boxShadow: '0 2px 6px rgb(0 0 0 / 30%)',
    },
    arrowButton: {
      color: '#0078d4',
      textDecoration: 'underline',
      display: 'inline-block',
      width: 24,
      height: 32,
      marginRight: 1,
      backgroundColor: '#243a5e',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: '12px 12px',
      '&:hover': {
        backgroundColor: '#50e6ff',
      },
      '&:focus': {
        outlineOffset: 1,
        color: '#0078d4',
      },
    },
    toHideArrowButton: {
      backgroundImage: `url(${ArrowRight})`,
      '&:hover': {
        backgroundImage: `url(${ArrowRightHover})`,
      },
      '&:focus': {
        backgroundImage: `url(${ArrowRightHover})`,
      },
    },
    toShowArrowButton: {
      backgroundImage: `url(${ArrowLeft})`,
      '&:focus': {
        backgroundImage: `url(${ArrowLeftFocus})`,
      },
    },
    chatButton: {
      display: 'inline-block',
      minHeight: 32,
      padding: '6px 17px 6px 17px',
      color: 'white',
      lineHeight: 1.333,
      textAlign: 'center',
      verticalAlign: 'middle',
      cursor: 'pointer',
      backgroundColor: '#0078d4',
      backgroundClip: 'unset',
      borderRadius: 0,
      border: 'none',
      outline: '1px dashed transparent',
      outlineOffset: 0,
      '&:hover': {
        color: 'white',
        textDecoration: 'none',
        backgroundColor: '#243a5e',
      },
      '&:focus': {
        backgroundColor: '#243a5e',
        outline: '1px dashed',
        outlineColor: 'white',
        outlineOffset: '-3px',
      },
    },
  };
}
